export default __webpack_public_path__ + "static/logo-white-6009d721033740d174649b687128e04a.svg";